import React from 'react';
import FormResponseMessage from "./formResponseMessage";
import '../style/postedApplicationPage.css'
import Button from "./button";
import {Link} from "react-router-dom";
import CenteredDots from "./General/centeredDots";
import { CANADA_COUNTRY, LEGAL_ACTION } from '../helpers/variables';
import { COUNTRY } from '../helpers/variables';


const PostedApplicationPage = (props) => {
    if(props.fetchingWording || props.fetchingPostedApplicationMessage){
        return (
            <div className={'col-sm-12'}>
                <CenteredDots/>
            </div>
        )
    }
    const policyLink = `${process.env.PUBLIC_URL}/application-and-policies/application-policy/${props.store.postedApplication.id}/policyschedule`;
    let content =<div className="" dangerouslySetInnerHTML={{__html:props.postedApplicationMessage.replaceAll('*policyLink*', policyLink)}}></div>;

    return (
        <div className="postedApplicationPage-wrapper">
            {props.shouldRender() && props.postedApplicationMessage && (
                <div>
                    {content}
                    <div className="agents-list-solicior-btns-wrapper">
                        <Button wrapper="btn-wrapper"
                                clickHandler={() => {
                                    props.changeApplicationsAndPoliciesField('selectedApplication', props.store.postedApplication);
                                    props.push('/application-and-policies/application-policy/'+props.store.postedApplication.id)
                                }}
                                btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label={props.store.postedApplication.policyStatus === 'Live'?'View policy':'View application'}/>
                        <Button wrapper="btn-wrapper"
                                clickHandler={() => {
                                    props.push('/application-and-policies')
                                }}
                                btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label="List applications"/>
                        <Button wrapper="btn-wrapper"
                                clickHandler={() => {
                                    props.push('/new-application')
                                }}
                                btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label="Create Another"/>
                    </div>
                </div>
            )
            }
        </div>
    )
};

export default PostedApplicationPage;